import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageTypeFilterMenuTitle
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface ISongsMobileFilterGroupFeaturesLogic {
  filterLabel: string;
}

export const useSongsMobileFilterGroupFeaturesLogic = (): ISongsMobileFilterGroupFeaturesLogic => {
  const filterLabel = useAppSelector(getMySongsPageTypeFilterMenuTitle);
  return {
    filterLabel,
  };
}
